module.exports = __webpack_public_path__ + "static/img/fgbg1-12.0f9aa62.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-12.png
// module id = 190
// module chunks = 0